import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

export const ProtectedRoutes = (): ReactElement => {
    const Component = withAuthenticationRequired(Outlet);
    return <Component />;
};
